import { useEffect } from 'react';

import type { UseCreateWarehouseEffectsProps } from '@app/pages/Warehouses/WarehouseRegistry/components/CreateWarehouse/types';

export const useCreateWarehouseEffects = ({
  handleGetBranches,
  handleGetWarehouse,
}: UseCreateWarehouseEffectsProps) => {
  useEffect(() => {
    handleGetBranches();
  }, [handleGetBranches]);

  useEffect(() => {
    handleGetWarehouse();
  }, [handleGetWarehouse]);
};
